import styled from "styled-components";

export const SecondaryHeadingWrapper = styled.div`
  h3 {
    font-size: 24px;
    font-weight: 600;
    line-height: 26.4px;
  }
`;
